import { Pager, VText } from '@vake/ui-kit';
import { FC } from 'react';

import { useGetAllReports } from '../../../requests/home.tsx/all-reports';
import { SpinnerImg } from '../../../shared/styles/Spinner';
import { useSetUpPager } from '../../../utils/setUpPager';
import { ReportRow } from './report-table-row';

const calculateNumRows = () => {
    const upper_height = document.getElementById('upper-element')?.clientHeight; // Everything above table header
    const lower_height = document.getElementById('lower-element')?.clientHeight; // Everything below table
    const padding = 64; // Padding around the whole page
    const margin = 25; // Tunable parameter ensuring table does not overextend
    if (upper_height && lower_height) {
        return Math.floor((window.innerHeight - (upper_height + lower_height + padding + margin)) / 43);
    } else return Math.floor((window.innerHeight - 300) / 43); // Fallback
};

export const ReportsTable: FC<{ searchQuery: string; filterReport: ReportType[] }> = ({
    searchQuery,
    filterReport,
}) => {
    const genericHeaders = ['Last Modified', 'Report Type', 'Team', 'Sidebar'];
    const { data, isLoading, isError } = useGetAllReports();
    const rowsPerPage = calculateNumRows();

    const filterBySearch = (row: AllReports) => {
        if (searchQuery.length > 0) {
            return (
                (((row.reportName && row.reportName.toLowerCase().includes(searchQuery)) ||
                    row.reportType.includes(searchQuery)) &&
                    filterReport.includes(row.reportType as ReportType)) ||
                (row.mmsi && Number(searchQuery) && String(row.mmsi).includes(searchQuery))
            );
        } else return filterReport.includes(row.reportType as ReportType);
    };

    const { firstPage, lastPage, currentPage, setCurrentPage, startIndex, endIndex } = useSetUpPager(
        data ? data.filter(filterBySearch).length : 0,
        rowsPerPage
    );
    return (
        <>
            <table className="table-fixed w-full border-separate border-spacing-y-4">
                <thead className="sticky top-0 text-left ">
                    <tr>
                        <th key="name" className="w-1/3">
                            <VText significance="tertiary">Name</VText>
                        </th>
                        {genericHeaders.map((header) => {
                            return (
                                <th key={header}>
                                    <VText significance="tertiary">{header}</VText>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <th>
                                <SpinnerImg size={35} src="/images/icons/Spinner.png" />
                            </th>
                        </tr>
                    ) : null}
                    {isError ? (
                        <tr>
                            <th>
                                <span>Oops something went wrong while getting the reports.</span>
                            </th>
                        </tr>
                    ) : null}

                    {data
                        ? data
                              .slice(startIndex, endIndex)
                              .filter(filterBySearch)
                              .map((item, i) => <ReportRow key={item.reportName + i} {...item} />)
                        : null}
                </tbody>
            </table>
            {data ? (
                <div className="flex justify-center" id="lower-element">
                    <Pager first={firstPage} last={lastPage} current={currentPage} onChange={setCurrentPage} />
                </div>
            ) : null}
        </>
    );
};
